import { signOut } from "firebase/auth";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";

const LogoutPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    signOut(auth).then(() => {
      navigate("/");
    });
  }, [navigate]);

  return null;
};

export default LogoutPage;
